import React from 'react'

const DateInput = React.forwardRef((props, ref) => (
  <div className='input-group'>
    <input 
      className='form-control' 
      placeholder='MM/DD/YYYY'
      ref={ref}
      value={props.value}
      disabled={props.disabled}
      onClick={props.onClick} 
      onChange={props.onChange}
    />
    <span className='input-group-addon'>
      <i className='fa fa-calendar-check-o'></i>
    </span>
  </div>
))

export default DateInput
